import { Component } from '@angular/core';

@Component({
  selector: 'app-checkcosp-submitform',
  templateUrl: './checkcosp-submitform.component.html',
  styleUrls: ['./checkcosp-submitform.component.scss']
})
export class CheckcospSubmitformComponent {

  selectedVersion: string = '1';

  selectVersion(version: string) {
    this.selectedVersion = version;
  }

  closePopup() {
    console.log('Popup Closed');
  }

  confirm() {
    console.log('Selected Version:', this.selectedVersion);

    // 👉 yaha API call / parent ko emit kar sakti ho
  }

}